import { AfterViewInit, Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { DomHelper } from '@barthauer/abc/core';
import { ResourceManager } from '@barthauer/abc/core/resources';
import { DialogResult, MessageBoxButtons, MessageBoxIcon, MessageMode } from './messages.model';
import { MessageSettings } from './messageSettings';

export interface DialogData {
  settings: MessageSettings;
}

@Component({
  selector: 'messages',
  templateUrl: './messageBox.component.html',
  styleUrls: ['./messageBox.component.scss'],
})
export class MessageBoxComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() settings: MessageSettings;
  public MessageBoxButtons = MessageBoxButtons;
  public res = ResourceManager.getResources('abc-messages-messageBox');
  public DialogResult = DialogResult;
  public errorMessageCaption: string = 'Erweiterte Fehlermeldung';
  private readonly registeredIconNames: Map<MessageBoxIcon, string> = new Map();
  private element: HTMLElement;
  private indexValue: string;

  constructor(
    public iconRegistry: MatIconRegistry,
    public sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<MessageBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.settings = data.settings;
    for (const entry of Object.entries(MessageBoxIcon.GetValues())) {
      const iconKey: string = this.createIconKey(entry[0]);
      const rawPath: MessageBoxIcon = entry[1];
      iconRegistry.addSvgIcon(iconKey, sanitizer.bypassSecurityTrustResourceUrl(rawPath));
      this.registeredIconNames.set(rawPath, iconKey);
    }
  }
  ngOnDestroy(): void {
    if (this.element) {
      this.element.style.removeProperty('z-index');
      this.element.style.setProperty('--index-value', this.indexValue ? this.indexValue : '1');
    }
  }

  private createIconKey(designation: string): string {
    return `MsgBox_${designation}`;
  }

  getIconKey(msgBoxIcon: MessageBoxIcon): string {
    return this.registeredIconNames.get(msgBoxIcon);
  }

  ngOnInit() {
    if (!this.settings.icon) {
      switch (this.settings.mode) {
        case MessageMode.Info: {
          this.settings.icon = MessageBoxIcon.Info;
          break;
        }
        case MessageMode.Error: {
          this.settings.icon = MessageBoxIcon.Error;
          break;
        }
        case MessageMode.Question: {
          this.settings.icon = MessageBoxIcon.Question;
          break;
        }
        case MessageMode.Warning: {
          this.settings.icon = MessageBoxIcon.Warning;
          break;
        }
      }
    }
    if (!this.settings.button) {
      switch (this.settings.mode) {
        case MessageMode.Info: {
          this.settings.button = MessageBoxButtons.OK;
          break;
        }
        case MessageMode.Error: {
          this.settings.button = MessageBoxButtons.OK;
          break;
        }
        case MessageMode.Question: {
          this.settings.button = MessageBoxButtons.YesNo;
          break;
        }
        case MessageMode.Warning: {
          this.settings.button = MessageBoxButtons.OK;
          break;
        }
        case MessageMode.None: {
          this.settings.button = MessageBoxButtons.OK;
          break;
        }
      }
    }
    if (this.settings.htmlcode) {
      const element = document.getElementById('htmlCode');
      element.appendChild(this.settings.htmlcode);
    }
  }
  ngAfterViewInit(): void {
    this.element = document.querySelector('.cdk-overlay-container') as HTMLElement;
    if (this.element) {
      this.indexValue = this.element.style.getPropertyValue('z-index');
      this.element.style.setProperty('z-index', `${DomHelper.getMaxZIndex() + 1} `, 'important');
    }
  }

  onClick(dialogResult: DialogResult) {
    this.dialogRef.close({ result: dialogResult });
  }

  toClipboard(item: string) {
    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', item);
      e.preventDefault();
      document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
  }
}
